import Icon from 'components/shared/Icon/Icon';

const BulletItem = ({ children, color = 'purple' }) => (
  <li className="flex items-start gap-2">
    <div className="flex h-5 items-center">
      {color === 'purple' && <Icon icon="dot-purple" />}
      {(color === 'blue' || color === 'primary') && <Icon icon="dot-blue" />}
      {color === 'neutral' && <Icon icon="dot-neutral" />}
    </div>
    <p className="text-sm text-neutral-800">{children}</p>
  </li>
);

export default BulletItem;
